import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const GoogleAnalytics = () => {
  const location = useLocation();

  useEffect(() => {
    // Track page view when location changes
    window.gtag('config', 'G-HW64Y0Y4P9', {
      page_path: location.pathname + location.search,
    });
  }, [location]);

  return null; // This component doesn't render anything
};

export default GoogleAnalytics;
